module.exports = __webpack_public_path__ + "static/media/background.8d8e76c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/Forgot/background.jpg
// module id = 606
// module chunks = 0